import { render } from "./accDelivery.vue?vue&type=template&id=6b500cfc"
import script from "./accDelivery.vue?vue&type=script&lang=js"
export * from "./accDelivery.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/marketing/accDelivery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b500cfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b500cfc', __exports__)) {
    console.log('reload')
    api.reload('6b500cfc', __exports__)
  }
  
  module.hot.accept("./accDelivery.vue?vue&type=template&id=6b500cfc", () => {
    console.log('re-render')
    api.rerender('6b500cfc', render)
  })

}


export default __exports__